export const SET_SOCIAL = "SET_SOCIAL";
